const attributes = {
	image: {
		type: 'object',
		default: {
			id: '',
			url: '',
			alt: '',
		},
	},
	sloganTitle: {
		type: 'string',
		default: '',
	},
	sloganDescription: {
		type: 'string',
		default: '',
	},
	config: {
		type: 'string',
	},
	enableLink: {
		type: 'boolean',
		default: false,
	},
	linkText: {
		type: 'string',
		default: 'Read more',
	},
	postType: {
		type: 'string',
		default: '',
	},
	linkedPost: {
		type: 'number',
		default: 0,
	},
	linkBorderThickness: {
		type: 'number',
		default: 1,
	},
	linkBorderRadius: {
		type: 'number',
		default: 30,
	},
	linkPaddingTopBottom: {
		type: 'number',
		default: 5,
	},
	linkPaddingLeftRight: {
		type: 'number',
		default: 10,
	},
	linkMarginTop: {
		type: 'number',
		default: 10,
	},
	linkBorderColor: {
		type: 'string',
		default: '#999999',
	},
	linkBGColor: {
		type: 'string',
		default: '#dddddd',
	},
	linkColor: {
		type: 'string',
		default: '#444444',
	},
	linkTarget: {
		type: 'string',
		default: '_blank',
	},
};

export default attributes;
